window.TTCart = (() => {
  async function fetchCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) throw new Error('Failed to fetch cart');
    return await res.json();
  }

  function isSellingPlanItem(item) {
    return Boolean(
      item.selling_plan_allocation ||
      item.selling_plan_id ||
      item.properties?._selling_plan ||
      item.properties?.selling_plan
    );
  }

  function getLineItemByVariantId(cart, variantId) {
    return (
      (cart.items || []).find(
        (item) =>
          Number(item.variant_id) === Number(variantId) &&
          !isSellingPlanItem(item)
      ) || null
    );
  }

  function getQuantityForVariant(cart, variantId) {
    return (cart.items || []).reduce((total, item) => {
      if (
        Number(item.variant_id) === Number(variantId) &&
        !isSellingPlanItem(item)
      ) {
        return total + item.quantity;
      }

      return total;
    }, 0);
  }

  function getBundledSections() {
    const detail = { sections: ['variant-added'] };

    document.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { detail })
    );

    return Array.from(new Set(detail.sections));
  }

  async function addVariant(variantId, quantity, sections) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity }],
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    });

    const data = await res.json();
    if (!res.ok) throw data;

    return data;
  }

  async function changeLine(line, quantity, sections) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity,
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    });

    const data = await res.json();
    if (!res.ok) throw data;

    return data;
  }

  async function setVariantQuantity(variantId, targetQuantity) {
    const quantity = Math.max(0, Number(targetQuantity) || 0);
    const existingCart = await fetchCart();
    const existingItem = getLineItemByVariantId(existingCart, variantId);
    const sections = getBundledSections();

    let sectionResponse = null;

    if (!existingItem && quantity > 0) {
      sectionResponse = await addVariant(variantId, quantity, sections);
    } else if (existingItem) {
      const lineIndex =
        existingCart.items.findIndex(
          (item) =>
            Number(item.variant_id) === Number(variantId) &&
            !isSellingPlanItem(item)
        ) + 1;

      sectionResponse = await changeLine(lineIndex, quantity, sections);
    } else {
      sectionResponse = { sections: {} };
    }

    const updatedCart = await fetchCart();
    updatedCart.sections = sectionResponse?.sections || {};

    document.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'cart:change',
          cart: updatedCart
        }
      })
    );

    return updatedCart;
  }

  return {
    fetchCart,
    getLineItemByVariantId,
    getQuantityForVariant,
    setVariantQuantity,
    isSellingPlanItem
  };
})();